let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fLRnq")).then(() => parcelRequire('1NLDX'));